var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirdTronTradeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E5003C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.85,
    stroke: "black",
    strokeOpacity: 0.62,
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8579 31C15.7705 30.8353 15.6963 30.7205 15.6436 30.5967C14.8876 28.7964 14.1337 26.9949 13.3817 25.1923C11.9049 21.6689 10.4282 18.147 8.95138 14.6266C7.68614 11.6031 6.4221 8.57952 5.15925 5.55599C5.15005 5.53909 5.14205 5.52163 5.1353 5.50373C5.0898 5.33786 5.0455 5.17085 5 5.00384C5.17456 4.99564 5.34952 5.00058 5.52326 5.01861C7.16129 5.30264 8.79572 5.59689 10.4326 5.88318C12.2646 6.20243 14.099 6.51372 15.931 6.83296C17.1176 7.03973 18.3006 7.26013 19.486 7.4669C20.8678 7.71003 22.2508 7.94406 23.6326 8.18378C24.26 8.29739 24.8874 8.40304 25.5113 8.52461C25.6354 8.55381 25.7494 8.61335 25.8418 8.6973C27.5229 10.206 29.202 11.7167 30.8792 13.2292C31.0348 13.3701 31.0384 13.4746 30.8995 13.6348C27.3497 17.7361 23.8022 21.8393 20.2571 25.9444C18.8849 27.5349 17.5095 29.1194 16.1309 30.6978C16.0651 30.7819 15.9872 30.8637 15.8579 31ZM15.7047 26.8544L15.7885 26.8351C15.8095 26.7855 15.8256 26.7341 15.8364 26.6817C16.0311 25.1707 16.2255 23.6597 16.4195 22.1487C16.6901 20.0083 16.9607 17.869 17.217 15.7275C17.2187 15.6565 17.2052 15.5859 17.1772 15.5201C17.1492 15.4542 17.1073 15.3945 17.0541 15.3446C16.6949 15.031 16.3105 14.7447 15.9346 14.4482C13.3562 12.4199 10.7774 10.3927 8.19823 8.36669C8.1334 8.32063 8.06583 8.27815 7.99587 8.23945L7.92762 8.28944L15.7047 26.8544ZM28.1407 14.572C28.0132 14.5635 27.8851 14.5635 27.7576 14.572C26.7769 14.7391 25.7975 14.9129 24.8168 15.081L21.1983 15.7013C20.4727 15.8252 19.747 15.9535 19.0202 16.074C18.8047 16.1092 18.685 16.2046 18.661 16.4216C18.6335 16.7227 18.5868 17.0226 18.5485 17.3237C18.3752 18.6756 18.2012 20.0272 18.0264 21.3784C17.8348 22.8811 17.644 24.3834 17.454 25.8853C17.4109 26.2261 17.3786 26.567 17.3415 26.9078L17.4265 26.9441L28.1407 14.572ZM23.6218 9.75159L23.5512 9.62435L9.12021 7.10449L9.05915 7.1931C9.14416 7.25331 9.23037 7.30671 9.31299 7.37601C10.0506 7.95315 10.7878 8.5318 11.5246 9.11197C13.5601 10.7127 15.5957 12.3101 17.6157 13.9222C17.8791 14.1324 18.0456 14.1142 18.2958 13.9131C19.965 12.5771 21.6485 11.2546 23.3248 9.92882C23.4195 9.86348 23.5187 9.80427 23.6218 9.75159ZM28.373 13.0122C28.3381 12.9517 28.298 12.8939 28.2533 12.8395C27.3385 12.0124 26.4189 11.1865 25.5053 10.3571C25.3652 10.231 25.2658 10.2537 25.1245 10.3662C23.8254 11.3967 22.5202 12.4203 21.2186 13.4485C20.8403 13.7472 20.4667 14.0529 20.0907 14.3573L20.1254 14.4289L28.373 13.0122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.64759 13.2902C6.97105 11.7647 8.12894 10.5652 8.72204 10.0211C10.4608 8.78809 11.3839 8.65541 12.5482 8.48805L12.5711 8.48476C14.3843 8.22406 18.3854 8.24807 20.0461 8.74051C22.1219 9.35606 23.3081 10.5871 24.009 11.8718C24.7099 13.1564 25.5187 15.1904 25.0065 19.2583C24.5967 22.5127 22.8767 23.701 21.421 24.5039L19.0216 25.735L16.1371 27.0196C14.7891 26.4754 11.581 25.098 9.53216 23.9418C6.97108 22.4966 6.48583 19.9006 6.35104 19.2583C6.06461 17.8934 6.29884 14.9349 6.64759 13.2902Z",
    fill: "url(#paint0_linear_1877_15032)",
    stroke: "black",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.90724 19.2266L6.46875 19.2266L6.54934 19.6351L6.65679 20.0982L6.81797 20.5885L7.03288 21.106C8.47275 21.1278 9.59384 21.0969 9.74607 21.0243C10.0254 20.6539 9.96097 19.5988 9.90724 19.2266Z",
    stroke: "black",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.9105 12.851C10.6303 11.5596 8.9629 10.7048 8.31641 10.4985C10.0665 8.52063 12.2526 8.41157 14.3928 8.3048L14.4393 8.30248C16.1899 8.21506 19.4346 8.3263 21.0928 9.1096C23.0861 10.0512 24.1905 11.7462 24.7024 13.3335C25.2142 14.9208 25.3219 17.6381 25.1064 19.0101C24.8512 20.6349 24.3803 23.2517 22.1164 23.9066C19.6112 24.6312 16.4326 24.3891 13.7658 23.7721C11.4069 23.2263 11.153 20.6267 11.0452 19.5234L11.0452 19.5231C10.9374 18.42 11.2607 14.4652 10.9105 12.851Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 17.4961,
    y: 20.8672,
    width: 2.54244,
    height: 0.656114,
    rx: 0.328057,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.9128 20.172C13.289 19.2607 11.7616 19.1685 11.0625 19.2499C11.1432 20.8229 11.2507 21.6094 11.9499 22.5857C12.5053 23.3614 13.4019 23.7519 14.3431 23.8604L14.3431 21.6365C14.3431 20.7415 14.0473 20.398 13.9128 20.172Z",
    stroke: "black",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.0237 13.108C9.72982 12.6735 8.67504 12.0867 8.10245 11.8047L7.49219 13.4509C7.90807 13.5058 9.36818 14.2969 10.0689 15.5773L10.3627 14.0454C10.3476 13.9463 10.2932 13.5065 10.0237 13.108Z",
    fill: "#CAA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.5985 23.4555L7.16797 21.2344L7.3187 21.5129L7.49097 21.8129C7.72013 22.1538 8.07063 22.6797 8.64339 23.1626C9.10172 23.5491 9.4699 23.8007 10.3866 24.2326L11.4942 24.802L14.2827 24.884L17.3992 24.9865L20.0237 25.0685L21.746 24.1869L21.9305 24.0434C19.823 24.6155 15.961 24.3875 13.7381 23.9784L10.5985 23.4555Z",
    fill: "#7057F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.7408 25.2109L14.4307 25.2109L15.6523 26.4822L12.7408 25.2109Z",
    fill: "#383740"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M9.55816 19.6367L6.96094 19.6367L7.16598 20.271L9.48981 20.2928C9.59917 20.1529 9.60373 19.7971 9.55816 19.6367Z",
    fill: "#826CF7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M13.112 25.2969L14.8971 25.2969L16.1875 26.6911L13.112 25.2969Z",
    fill: "#634AE4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.2656 24.8867L20.2462 25.1652L19.3051 25.6664L18.9825 25.8334L18.7673 25.9448L16.1323 27.1421L14.8686 26.6131L13.6049 26.0283L11.2656 24.8867Z",
    fill: "#7057F0",
    stroke: "black",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M12.7429 25.293L14.7851 25.293L16.0234 26.6872L12.7429 25.293Z",
    fill: "#644AE7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 11.7188,
    y: 14.1406,
    width: 6.11006,
    height: 4.0187,
    rx: 2.00935,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter0_f_1877_15032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.7165,
    cy: 16.0892,
    rx: 2.52897,
    ry: 1.56182,
    fill: "#A00C36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    filter: "url(#filter1_f_1877_15032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.6862,
    cy: 16.1804,
    rx: 1.61978,
    ry: 1.08669,
    fill: "#EC0828"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    d: "M11.5758 14.1406L17.7877 14.1406L17.7877 12.9244L16.2862 10.1219L13.5299 12.5807L12.234 12.9244L11.3906 13.4797L11.5758 14.1406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 17.8281,
    y: 14.1406,
    width: 0.943164,
    height: 3.77266,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    d: "M11.3896 18.0576L11.6767 17.463L11.7587 17.7706L11.9432 17.9961L12.1482 18.1191L12.3533 18.1806L11.8371 18.5375L11.3896 18.0576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6",
    d: "M18.3146 18.1543L17.9407 17.3441L17.8503 17.503L17.8093 17.708L17.6987 17.9131L17.5223 18.0566L17.3377 18.1386L17.1737 18.1796L17.0097 18.2976L17.6987 18.7921L18.3146 18.1543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    d: "M18.2588 18.1172L24.4508 18.1172L24.4508 19.0604L22.9541 21.2337L20.2066 19.3269L18.9149 19.0604L18.0742 18.6298L18.2588 18.1172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    d: "M18.4429 14.1016L24.6549 14.1016L24.0808 12.8854L22.1535 10.5955L20.397 12.5417L19.1012 12.8854L18.2578 13.4406L18.4429 14.1016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    x: 18.0938,
    y: 14.3477,
    width: 0.492085,
    height: 3.77266,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    d: "M18.2607 18.0147L18.5478 17.4201L18.6298 17.7276L18.8143 17.9531L19.0193 18.0761L19.2244 18.1376L18.7082 18.4945L18.2607 18.0147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    d: "M24.9186 18.1405L24.804 17.305L24.7136 17.4639L24.6726 17.669L24.562 17.874L24.3855 18.0175L24.201 18.0995L24.037 18.1405L23.873 18.2586L24.562 18.753L24.9186 18.1405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    x: 18.3672,
    y: 14.1406,
    width: 6.11006,
    height: 4.0187,
    rx: 2.00935,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4",
    filter: "url(#filter2_f_1877_15032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4066,
    cy: 16.1751,
    rx: 2.59021,
    ry: 1.56182,
    fill: "#A00C36"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13",
    d: "M18.3302 18.5757L19.0721 18.2333L18.9266 18.1505L18.7388 18.1129L18.551 18.0117L18.4196 17.8501L18.3445 17.6811L18.3069 17.5309L18.1988 17.3807L17.7461 18.0117L18.3302 18.5757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    x: 17.8672,
    y: 14.2656,
    width: 0.492085,
    height: 3.77266,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    filter: "url(#filter3_f_1877_15032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4596,
    cy: 16.2117,
    rx: 1.61978,
    ry: 1.08669,
    fill: "#EC0828"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M14.5043 17.845C14.4935 17.8234 14.4843 17.8082 14.4778 17.7919C14.3845 17.5549 14.2914 17.3177 14.1986 17.0804C14.0164 16.6165 13.8341 16.1528 13.6518 15.6893C13.4956 15.2912 13.3396 14.8932 13.1837 14.4951C13.1826 14.4929 13.1816 14.4906 13.1808 14.4882C13.1751 14.4664 13.1697 14.4444 13.1641 14.4224C13.1856 14.4213 13.2072 14.422 13.2286 14.4243C13.4308 14.4617 13.6326 14.5005 13.8346 14.5382C14.0607 14.5802 14.2872 14.6212 14.5133 14.6632C14.6598 14.6904 14.8058 14.7194 14.9521 14.7467C15.1226 14.7787 15.2934 14.8095 15.4639 14.8411C15.5414 14.856 15.6188 14.8699 15.6958 14.8859C15.7111 14.8898 15.7252 14.8976 15.7366 14.9087C15.9441 15.1073 16.1514 15.3062 16.3584 15.5053C16.3776 15.5239 16.378 15.5376 16.3609 15.5587C15.9227 16.0987 15.4848 16.6389 15.0473 17.1794C14.8779 17.3888 14.7081 17.5974 14.538 17.8053C14.5298 17.8163 14.5202 17.8271 14.5043 17.845ZM14.4854 17.2992L14.4957 17.2967C14.4983 17.2902 14.5003 17.2834 14.5016 17.2765C14.5257 17.0776 14.5496 16.8786 14.5736 16.6797C14.607 16.3979 14.6404 16.1162 14.672 15.8343C14.6722 15.8249 14.6706 15.8156 14.6671 15.807C14.6637 15.7983 14.6585 15.7904 14.6519 15.7838C14.6076 15.7426 14.5601 15.7049 14.5137 15.6658C14.1955 15.3988 13.8772 15.1319 13.5588 14.8651C13.5508 14.8591 13.5425 14.8535 13.5338 14.8484L13.5254 14.855L14.4854 17.2992ZM16.0204 15.6821C16.0046 15.681 15.9888 15.681 15.9731 15.6821C15.852 15.7041 15.7311 15.727 15.6101 15.7491L15.1634 15.8308C15.0739 15.8471 14.9843 15.864 14.8946 15.8799C14.868 15.8845 14.8532 15.8971 14.8503 15.9256C14.8469 15.9653 14.8411 16.0048 14.8364 16.0444C14.815 16.2224 14.7935 16.4004 14.7719 16.5783C14.7483 16.7761 14.7247 16.9739 14.7013 17.1716C14.696 17.2165 14.692 17.2614 14.6874 17.3063L14.6979 17.311L16.0204 15.6821ZM15.4626 15.0475L15.4539 15.0307L13.6726 14.699L13.6651 14.7106C13.6756 14.7185 13.6862 14.7256 13.6964 14.7347C13.7875 14.8107 13.8785 14.8869 13.9694 14.9633C14.2207 15.174 14.4719 15.3843 14.7212 15.5966C14.7538 15.6242 14.7743 15.6219 14.8052 15.5954C15.0112 15.4195 15.219 15.2454 15.4259 15.0708C15.4376 15.0622 15.4499 15.0544 15.4626 15.0475ZM16.049 15.4768C16.0447 15.4688 16.0398 15.4612 16.0343 15.454C15.9213 15.3451 15.8078 15.2364 15.6951 15.1272C15.6778 15.1106 15.6655 15.1136 15.6481 15.1284C15.4877 15.2641 15.3266 15.3988 15.166 15.5342C15.1192 15.5735 15.0731 15.6138 15.0267 15.6539L15.031 15.6633L16.049 15.4768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M21.3832 17.845C21.3724 17.8234 21.3632 17.8082 21.3567 17.7919C21.2634 17.5549 21.1704 17.3177 21.0775 17.0804C20.8953 16.6165 20.713 16.1528 20.5307 15.6893C20.3745 15.2912 20.2185 14.8932 20.0626 14.4951C20.0615 14.4929 20.0605 14.4906 20.0597 14.4882C20.0541 14.4664 20.0486 14.4444 20.043 14.4224C20.0645 14.4213 20.0861 14.422 20.1076 14.4243C20.3097 14.4617 20.5115 14.5005 20.7135 14.5382C20.9396 14.5802 21.1661 14.6212 21.3922 14.6632C21.5387 14.6904 21.6847 14.7194 21.831 14.7467C22.0016 14.7787 22.1723 14.8095 22.3428 14.8411C22.4203 14.856 22.4977 14.8699 22.5747 14.8859C22.59 14.8898 22.6041 14.8976 22.6155 14.9087C22.823 15.1073 23.0303 15.3062 23.2373 15.5053C23.2565 15.5239 23.2569 15.5376 23.2398 15.5587C22.8016 16.0987 22.3638 16.6389 21.9262 17.1794C21.7568 17.3888 21.587 17.5974 21.4169 17.8053C21.4087 17.8163 21.3991 17.8271 21.3832 17.845ZM21.3643 17.2992L21.3746 17.2967C21.3772 17.2902 21.3792 17.2834 21.3805 17.2765C21.4046 17.0776 21.4286 16.8786 21.4525 16.6797C21.4859 16.3979 21.5193 16.1162 21.5509 15.8343C21.5511 15.8249 21.5495 15.8156 21.546 15.807C21.5426 15.7983 21.5374 15.7904 21.5308 15.7838C21.4865 15.7426 21.439 15.7049 21.3926 15.6658C21.0744 15.3988 20.7561 15.1319 20.4377 14.8651C20.4297 14.8591 20.4214 14.8535 20.4128 14.8484L20.4043 14.855L21.3643 17.2992ZM22.8993 15.6821C22.8835 15.681 22.8677 15.681 22.852 15.6821C22.7309 15.7041 22.61 15.727 22.489 15.7491L22.0423 15.8308C21.9528 15.8471 21.8632 15.864 21.7735 15.8799C21.7469 15.8845 21.7321 15.8971 21.7292 15.9256C21.7258 15.9653 21.72 16.0048 21.7153 16.0444C21.6939 16.2224 21.6724 16.4004 21.6508 16.5783C21.6272 16.7761 21.6036 16.9739 21.5802 17.1716C21.5749 17.2165 21.5709 17.2614 21.5663 17.3063L21.5768 17.311L22.8993 15.6821ZM22.3415 15.0475L22.3328 15.0307L20.5515 14.699L20.544 14.7106C20.5545 14.7185 20.5651 14.7256 20.5753 14.7347C20.6664 14.8107 20.7574 14.8869 20.8483 14.9633C21.0996 15.174 21.3508 15.3843 21.6001 15.5966C21.6327 15.6242 21.6532 15.6219 21.6841 15.5954C21.8901 15.4195 22.0979 15.2454 22.3048 15.0708C22.3165 15.0622 22.3288 15.0544 22.3415 15.0475ZM22.9279 15.4768C22.9236 15.4688 22.9187 15.4612 22.9132 15.454C22.8002 15.3451 22.6867 15.2364 22.574 15.1272C22.5567 15.1106 22.5444 15.1136 22.527 15.1284C22.3666 15.2641 22.2055 15.3988 22.0449 15.5342C21.9982 15.5735 21.952 15.6138 21.9056 15.6539L21.9099 15.6633L22.9279 15.4768Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_15032",
    x: 11.4875,
    y: 13.8273,
    width: 6.45859,
    height: 4.525,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.35,
    result: "effect1_foregroundBlur_1877_15032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_15032",
    x: 12.2664,
    y: 14.2937,
    width: 4.83828,
    height: 3.77188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "effect1_foregroundBlur_1877_15032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1877_15032",
    x: 18.1164,
    y: 13.9133,
    width: 6.57969,
    height: 4.525,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.35,
    result: "effect1_foregroundBlur_1877_15032"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1877_15032",
    x: 19.0398,
    y: 14.325,
    width: 4.83828,
    height: 3.77188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "effect1_foregroundBlur_1877_15032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1877_15032",
    x1: 8.191,
    y1: 10.8012,
    x2: 13.4941,
    y2: 27.0213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B589FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491707,
    stopColor: "#AF86FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738033,
    stopColor: "#866FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806CF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdTronTradeIcon);
export default __webpack_public_path__ + "static/media/ThirdTronTradeIcon.f655ae59b343ee3b065c956b7b706924.svg";
export { ForwardRef as ReactComponent };